import styled, { css } from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { grey1, grey5, grey6 } from 'approot/shared/styles/colours.style';
import {
  spacing24,
  spacing40,
  spacing80,
} from 'approot/shared/styles/spacing.style';
import { hexColourToRGBArray } from 'lib/strings/strings.colour';
import {
  ACTIVITY_BUILDER_SLIDE_BREAKPOINT,
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  SLIDE_HEIGHT_MINUS_HEADER_FOOTER,
} from '../activity-builder.constants';

export const ActivityBuilderSlideContent = styled.div`
  padding: ${rem(spacing24)} ${rem(spacing24)} 0 ${rem(spacing24)};
`;

type ActivityBuilderSlideExtraProps = {
  $index: number;
  $length: number;
};
export const ActivityBuilderSlideExtra = styled.div<ActivityBuilderSlideExtraProps>`
  background-color: ${grey1};
  border-radius: ${rem(12)};
  border: 1px solid ${grey5};
  box-shadow:
    0px 16px 24px 0px rgba(${hexColourToRGBArray(grey6).join(',')}, 0.08),
    0px 4px 8px -4px rgba(${hexColourToRGBArray(grey6).join(',')}, 0.08);
  max-width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  transform: translate3d(
    ${({ $index }) => $index * 8}px,
    -${({ $index }) => $index * 8}px,
    0
  );
  z-index: ${({ $length, $index }) => $length - $index};
`;

type ActivityBuilderPresentSlideProps = {
  $zIndex: number;
};
export const ActivityBuilderPresentSlide = styled.div<ActivityBuilderPresentSlideProps>`
  background-color: ${grey1};
  box-shadow:
    0px 16px 24px 0px rgba(${hexColourToRGBArray(grey6).join(',')}, 0.08),
    0px 4px 8px -4px rgba(${hexColourToRGBArray(grey6).join(',')}, 0.08);
  border-radius: ${rem(12)};
  border: 1px solid ${grey5};
  position: relative;
  max-width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
  z-index: ${({ $zIndex }) => $zIndex};

  @media (${ACTIVITY_BUILDER_SLIDE_BREAKPOINT}) {
    min-height: ${rem(SLIDE_HEIGHT_MINUS_HEADER_FOOTER)};
  }
`;

type ActivityBuilderPresentSlideRowProps = {
  $isZoomToFit: boolean;
  $isLoading?: boolean;
  $hasBanner?: boolean;
};

export const ActivityBuilderPresentSlideRow = styled.div<ActivityBuilderPresentSlideRowProps>`
  margin: auto;
  position: relative;
  width: 100%;

  ${({ $hasBanner }) =>
    $hasBanner
      ? css`
          padding: ${rem(200)} ${rem(spacing40)} ${rem(spacing80)}
            ${rem(spacing40)};
          ${mediaUp.sm`
            padding-top: ${rem(160)};
          `}
        `
      : `
    padding: ${rem(spacing80)} ${rem(spacing40)};
  `}

  ${ActivityBuilderSlideContent} {
    ${({ $isLoading }) =>
      $isLoading
        ? `
    opacity: 0;
  `
        : `
    opacity: 1;
    transition: opacity 300ms ease;
  `};
  }

  ${({ $isZoomToFit }) =>
    $isZoomToFit &&
    `
      ${ActivityBuilderSlideExtra}, ${ActivityBuilderPresentSlide} {
        width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
        min-height: ${rem(SLIDE_HEIGHT_MINUS_HEADER_FOOTER)};
      }
    `}
`;

export const ActivityBuilderPresentSlideRowInner = styled.div`
  position: relative;
  margin: auto;
  max-width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
`;
